import {
    resourceGetDetail,
    resourcePostList,
    resourceGetList
} from "shared/djangio/action-creators"

import { createNewPDFEmailTypes } from "app/static/frontend/download-center/containers/control-panel/action-types"
import { loadOrganizationDesignTypes } from "app/static/frontend/download-center/action-types"
import { saveNewTemplateTypes } from "app/static/frontend/download-center/containers/template-manager/action-types"

/**
 * Loads the default organization design. This is the initial design
 * that the display panel will use.
 *     Note: After loading the default, the control panel's
 * OrgDesignSelect gives the fill org object when this changes,
 * so this is only needed on initial load.
 */
export const loadDefaultOrganizationDesign = () => resourceGetDetail(
    DjangIO.app.userdata.models.OrganizationDesign,
    loadOrganizationDesignTypes,
    Userdata.default_design_id,
    { id: Userdata.default_design_id },
    true
)

/**
 * Create a NewDownloadTemplate with the given name and store. Store is in the format:
 *     {
 *         profileQdt: <profileQdt>
 *         <profileQdt>: {
                pages: {...},
                elementDetails: {...},
                layout: [...],
                ...
            }
 *     }
 *
 * Note: This used to be included in download-center/action-creators but if we import that file
 * here, numerous circular dependency errors pop up in jest. Thus, this action creator
 * was moved here and the dlc imports this file to appease those issues.
 *
 * @param  {String} name  [name of template]
 * @param  {Object} store [object]
 * @param  {Number} templateType [value of NewDownloadTemplateType (optional - the default is custom)]
 */
export const saveNewTemplate = ({
    name,
    store,
    templateType,
    profileId,
}) =>
    resourcePostList(
        DjangIO.app.pdfdownload.models.NewDownloadTemplate,
        saveNewTemplateTypes,
        {
            name,
            store,
            data_type: store.profileQdt,
            creator: DjangIO.app.userdata.models.QuorumUser.foreignKey(Userdata.id),
            last_editor: DjangIO.app.userdata.models.QuorumUser.foreignKey(Userdata.id),
            template_type: templateType,
            organization: DjangIO.app.userdata.models.Organization.foreignKey(Userdata.organization_id)
        },
        { profileId }
    )

/**
 * Create a NewPDFEmail that will process an automated search download in process_pdf_email.
 * @param  {String} name     [The name of the NewPDFEmail created]
 * @param  {Object} template [the NewDownloadTemplate that will be downloaded]
 */
export const saveNewPDFEmailForSearchDownloads = ({
    name,
    newTemplate,
}) =>
    resourcePostList(
        DjangIO.app.pdfdownload.models.NewPDFEmail,
        createNewPDFEmailTypes,
        {
            creator: DjangIO.app.userdata.models.QuorumUser.foreignKey(Userdata.id),
            logged_in_as_user_id: Userdata.logged_in_as_user_id || Userdata.id,
            pdf_email_type: DjangIO.app.pdfdownload.types.NewPDFEmailType.search_download_zip.value,
            template: newTemplate && newTemplate.resource_uri,
            title: name,
        },
        {}
    )
